import DynamicAction from './DynamicAction';
export default DynamicAction;